import * as _ from '@baidu/bce-i18n';
import {PipelineType, QualifyFaceType} from '@/types/api/qualify';

export const USER_CENTER = '/iam/#/iam/baseinfo';
export const HOME_PAGE = 'https://cloud.baidu.com/?from=qualify';

export const H5_TICKET_URL = {
    sandbox: 'https://ctssmartprogram.baidu.com/dev/ticket/h5/index.html?src=qualify#/',
    online: 'https://ctssmartprogram.baidu.com/ticket/h5/index.html?src=qualify#/',
};
export const PC_TICKET_CREATE = '/#/ticket/assistant?useticket=1&productId=15&questionId=410&createDirectly=1';

export const NEW_USER_GUIDE = 'https://cloud.baidu.com/campaign/experience/index.html?track=qualify';
export const APP_QR_IMAGE = 'https://bcecdn.bj.bcebos.com/eop-fe/risk/qualify/bce-app-qrcode.png';
export const BAIDU_APP_DOWNLOAD_QR = 'https://bcecdn.bj.bcebos.com/eop-fe/risk/qualify/baidu_app_qrcode.png';

// 实名结果页营销参数
export const RESULT_MARKETING_URL = {
    sandbox: 'https://bce.bdstatic.com/portal-cms/online/console/pre_marketing.js',
    online: 'https://bce.bdstatic.com/portal-cms/online/console/marketing.js',
};

export const PIPELINE_TYPE_NAME: {
    [key: string]: string;
} = {
    // 企业充值认证
    CORPORATION_TO_BAIDU_PAYMENT: '百度云充值认证',
    // 企业对公打款认证
    TRANSFER_TO_CORPORATION_UNION_PAY: '企业对公打款认证',
    // 企业法人活体认证
    LEGAL_PERSON_FACE_AUTH_BAIDU_AI: '法定代表人刷脸认证',
    // 个人活体认证
    PERSONAL_LIVING_BODY_AUTH: '个人刷脸认证',
    // 个人银行卡认证
    PERSON_BANK_CARD_AUTH_UNION_PAY: '个人银行卡认证',
    // 个人手持证件照认证
    PERSONAL_CERTIFICATE_AUTH: '个人证件认证',
    // 一键同步百度账号认证
    PASSPORT_SYNC: '一键同步认证',
    // 绿色通道
    SPECIAL_CHANNEL: '线下实名认证',
    // 法人刷脸认证
    CORPORATION_LEGAL_PERSON_LIVING_BODY_AUTH: '法定代表人刷脸认证',
    // 法人被授权人刷脸
    AUTHORIZED_PERSON_LIVING_BODY_AUTH: '法定代表被授权人刷脸认证',
    // 企业主体变更
    CORPORATION_APPLY_FORM_CHANGE_AUTH: '企业主体变更',
    // 企业名称变更
    CORPORATION_NAME_CHANGE_AUTH: '企业名称变更',
};

export enum FACE_TYPE {
    // 个人刷脸
    PERSONAL = 'PERSONAL',
    // 法人刷脸
    LEGAL = 'LEGAL',
    // 被授权人刷脸
    REPRESENTATIVE = 'REPRESENTATIVE',
    // 对公打款经办人刷脸
    REMIT = 'REMIT',
    // 鉴权
    PERSONAL_H5 = 'PERSONAL_H5',
    // 变更原主体
    CHANGE_PERSON_ORIGIN = 'CHANGE_PERSON_ORIGIN',
    // 企业变更企业
    COMPANY = 'COMPANY',
}

// 刷脸的类型标签
export enum FACE_TYPE_LABEL {
    PERSONAL = '个人',
    LEGAL = '法定代表人',
    REPRESENTATIVE = '被授权人',
    CHANGE_PERSON_ORIGIN = '变更原主体',
    PERSONAL_H5 = '',
    COMPANY = '企业变更原主体',
}

export const STATUS_CLASS: {
    [key: string]: string;
} = {
    RETURN: 'danger',
    PASS: 'success',
    AUDIT: 'warning',
};

// 认证方式
export enum PIPELINE_TYPE {
    // 企业充值认证
    CORPORATION_TO_BAIDU_PAYMENT = 'CORPORATION_TO_BAIDU_PAYMENT',
    // 企业对公打款认证
    TRANSFER_TO_CORPORATION_UNION_PAY = 'TRANSFER_TO_CORPORATION_UNION_PAY',
    // 企业法人活体认证
    LEGAL_PERSON_FACE_AUTH_BAIDU_AI = 'LEGAL_PERSON_FACE_AUTH_BAIDU_AI',
    // 个人活体认证
    PERSONAL_LIVING_BODY_AUTH = 'PERSONAL_LIVING_BODY_AUTH',
    // 个人银行卡认证
    PERSON_BANK_CARD_AUTH_UNION_PAY = 'PERSON_BANK_CARD_AUTH_UNION_PAY',
    // 绿色通道
    SPECIAL_CHANNEL = 'SPECIAL_CHANNEL',
    // 法人被授权人刷脸
    AUTHORIZED_PERSON_LIVING_BODY_AUTH = 'AUTHORIZED_PERSON_LIVING_BODY_AUTH',
    // 个人证件认证
    PERSONAL_CERTIFICATE_AUTH = 'PERSONAL_CERTIFICATE_AUTH',
    // app的个人刷脸认证
    PERSON_LIVING_AUTH = 'PERSON_LIVING_AUTH',
    // 企业变更企业申请表认证
    CORPORATION_APPLY_FORM_CHANGE_AUTH = 'CORPORATION_APPLY_FORM_CHANGE_AUTH',
    // 企业变更名称
    CORPORATION_NAME_CHANGE_AUTH = 'CORPORATION_NAME_CHANGE_AUTH',
    NONE = 'NONE',
}

// 组织类型

export enum ORGANIZATION_TYPE {
    'ENTERPRISE' = 'ENTERPRISE',
    'DEPARTMENT' = 'DEPARTMENT',
}

export const COMPANY_TYPE: Array<{
    label: string;
    value: ORGANIZATION_TYPE;
}> = [
    {label: '企业', value: ORGANIZATION_TYPE.ENTERPRISE},
    {label: '其他组织', value: ORGANIZATION_TYPE.DEPARTMENT},
];


// 对公打款提交状态
export enum COMPANY_TRANSFER_STATUS {
    // 对公打款初始状态
    TRANSFER_TO_CORPORATION_INIT = 'TRANSFER_TO_CORPORATION_INIT',
    // 对公打款提交状态
    TRANSFER_TO_CORPORATION_SUBMIT = 'TRANSFER_TO_CORPORATION_SUBMIT',
    // 对公打款认证成功
    TRANSFER_TO_CORPORATION_PASS = 'TRANSFER_TO_CORPORATION_PASS',
    // 对公打款认证失败
    TRANSFER_TO_CORPORATION_RETURN = 'TRANSFER_TO_CORPORATION_RETURN',
    // 对公打款送审
    TRANSFER_TO_CORPORATION_HUMAN_AUDIT_SEND = 'TRANSFER_TO_CORPORATION_HUMAN_AUDIT_SEND',
    // 对公打款审核中
    TRANSFER_TO_CORPORATION_HUMAN_AUDIT = 'TRANSFER_TO_CORPORATION_HUMAN_AUDIT',
    // 对公打款经办人刷脸提交
    TRANSFER_TO_CORPORATION_FACE_AUTH_SUBMIT = 'TRANSFER_TO_CORPORATION_FACE_AUTH_SUBMIT',
    // 对公打款经办人刷脸通过
    TRANSFER_TO_CORPORATION_FACE_AUTH_PASS = 'TRANSFER_TO_CORPORATION_FACE_AUTH_PASS',
    // 对公打款经办人刷脸失败
    TRANSFER_TO_CORPORATION_FACE_AUTH_FAIL = 'TRANSFER_TO_CORPORATION_FACE_AUTH_FAIL',
    // 对公打款刷脸成功提交失败
    TRANSFER_TO_CORPORATION_FACE_AUTH_PASS_RETRY = 'TRANSFER_TO_CORPORATION_FACE_AUTH_PASS_RETRY',
    // 撤回
    WITHDRAW = 'WITHDRAW',
}

// 对公打款提交状态对应步骤条
export const COMPANY_TRANSFER_STEP = [
    {title: _('填写验证信息')},
    {title: _('经办人刷脸验证')},
    {title: _('回填金额验证（平台预计0-2日完成打款）')},
    {title: _('认证完成')},
];

// 法人刷脸认证步骤条
export const COMPANY_LEGAL_STEP = [
    {title: _('填写认证信息')},
    {title: _('法人/被授权人扫脸验证')},
    {title: _('认证完成')},
];

// 被授权人认证步骤条
export const COMPANY_REPRESENTATIVE_STEP = [
    {title: _('填写认证信息')},
    {title: _('法人/被授权人扫脸验证')},
    {title: _('百度云审核（被授权人预计0-2日）')},
    {title: _('认证完成')},
];

// 百度智能云充值认证步骤条
export const BAIDU_RECHARGE_STEP = [
    {title: _('填写认证信息')},
    {title: _('专属账号汇款')},
    {title: _('汇款金额验证')},
    {title: _('认证完成')},
];

// 个人刷脸认证步骤条
export const PERSON_FACE_STEP = [
    {title: _('填写认证信息')},
    {title: _('个人扫脸验证')},
    {title: _('认证完成')},
];

// 个人银行卡认证步骤条
export const PERSON_BANK_STEP = [
    {title: _('填写认证信息')},
    {title: _('认证完成')},
];

export const IMAGE_URL = '/api/qualify/get_file?filename=';
export const LICENSE_IMG_URL = '/api/qualify/license/get_file?filename=';

export enum AUTH_CHANNEL {
    NEW_USER_PERSON = 'NEW_USER_PERSON',
    OLD_USER_PERSON = 'OLD_USER_PERSON',
    NEW_USER_CORPORATION = 'NEW_USER_CORPORATION',
    OLD_USER_CORPORATION = 'OLD_USER_CORPORATION',
}

// 企业高级认证审核状态
export enum QUALIFY_STATUS {
    // 未提交认证
    NONE= 'NONE',
    // 提交认证，尚未通过
    SUBMIT= 'SUBMIT',
    // 审核中
    AUDIT= 'AUDIT',
    // 被拒绝
    RETURN= 'RETURN',
    // 已通过
    PASS= 'PASS',
    // 已撤回
    WITHDRAW= 'WITHDRAW',
    // 待送审
    AUDIT_SEND= 'AUDIT_SEND',
    // 推送人审
    HUMAN_AUDIT= 'HUMAN_AUDIT',
}

export const DOC_OPTIONS = [
    {label: '大陆二代居民身份证', value: 'MAINLAND'},
    {label: '港澳台居民来往内地通行证', value: 'EXIT_ENTRY_PERMIT'},
    {label: '外国人永久居留证', value: 'PERMANENT_RESIDENCE'},
    {label: '定居国外的中国公民护照', value: 'CHINESE_PASSPORTS'},
];

export enum CERTIFICATE {
    MAINLAND = 'MAINLAND',
    EXIT_ENTRY_PERMIT = 'EXIT_ENTRY_PERMIT',
    PERMANENT_RESIDENCE = 'PERMANENT_RESIDENCE',
    CHINESE_PASSPORTS = 'CHINESE_PASSPORTS',
}

export const CERTIFICATE_LABEL = {
    [CERTIFICATE.MAINLAND]: {
        label: '身份证号',
        name: '大陆二代居民身份证',
    },
    [CERTIFICATE.EXIT_ENTRY_PERMIT]: {
        label: '证件号',
        name: '港澳台居民来往内地通行证',
    },
    [CERTIFICATE.PERMANENT_RESIDENCE]: {
        label: '证件号',
        name: '外国人永久居留证',
    },
    [CERTIFICATE.CHINESE_PASSPORTS]: {
        label: '证件号',
        name: '定居国外的中国公民护照',
    },
};

export const PASS_QUALIFY_STATUS = {
    // 未认证
    UNKNOWN: 'UNKNOWN',
    // 初级认证
    PRIME: 'PRIME',
    // 高级认证
    SENIOR: 'SENIOR',
};


// 结果页的认证状态
export enum RESULT_STATUS {
    // 新用户被撤回
    COMPANY_WITHDRAW = 'COMPANY_WITHDRAW',
    // 存量企业初级通过，高级已撤回
    COMPANY_SENIOR_WITHDRAW = 'COMPANY_SENIOR_WITHDRAW',
    // 存量企业初级通过，高级未申请
    COMPANY_JUNIOR_PASS= 'COMPANY_JUNIOR_PASS',
    // 存量企业初级被拒绝，或者新认证被拒绝
    COMPANY_RETURN = 'COMPANY_RETURN',
    // 企业初级通过，高级被拒绝
    COMPANY_SENIOR_RETURN = 'COMPANY_SENIOR_RETURN',
    // 企业认证通过：高级通过或者新流程通过
    COMPANY_PASS = 'COMPANY_PASS',
    // 对公打款认证已提交-刷脸失败/打款金额认证失败在后端流程状态中都处于SUBMIT，但前端需要将对公打款场景单独处理，所以新增一个流程状态
    COMPANY_TRANSFER_SUBMIT = 'COMPANY_TRANSFER_SUBMIT',
    // 新用户被撤回
    PERSON_WITHDRAW = 'PERSON_WITHDRAW',
    // 存量初级通过，高级已撤回
    PERSON_SENIOR_WITHDRAW = 'PERSON_SENIOR_WITHDRAW',
    // 存量个人初级通过，高级未申请
    PERSON_JUNIOR_PASS = 'PERSON_JUNIOR_PASS',
    // 存量个人初级未通过，新流程未通过
    PERSON_RETURN = 'PERSON_RETURN',
    // 存量个人初级通过，个人高级被拒绝
    PERSON_SENIOR_RETURN = 'PERSON_SENIOR_RETURN',
    // 个人认证通过,个人高级初级通过，个人新流程通过，个人pass高级通过
    PERSON_PASS = 'PERSON_PASS',
    //  个人账号需要同步PASS：个人未认证或者存量初级认证，passInfo 高级认证
    PERSON_NEED_PASS_SYNC = 'PERSON_NEED_PASS_SYNC',
    // 个人初级认证失败转企业初级认证失败，新用户个人认证失败转企业认证失败
    PERSON_RETURN_TO_COMPANY_RETURN = 'PERSON_RETURN_TO_COMPANY_RETURN',
    // 个人初级认证成功转企业初级认证失败
    PERSON_PASS_TO_COMPANY_RETURN = 'PERSON_PASS_TO_COMPANY_RETURN',
    // 认证审核中
    IN_AUDIT = 'IN_AUDIT',
    // 未认证
    INIT = 'INIT',
}

export const TIME_FORMATE = 'YYYY-MM-DD HH:mm';

export const TIME_FORMATE_SECOND = 'YYYY-MM-DD HH:mm:ss';

export enum PERSON_CHANGE_STEP {
    ORIGIN_INIT = 'ORIGIN_INIT',
    // 原主体认证审核中
    ORIGIN_AUDIT = 'ORIGIN_AUDIT',
    // 原主体认证失败
    ORIGIN_RETURN= 'ORIGIN_RETURN',
    // 原主体认证已通过，新主体认证未提交
    ORIGIN_PASS= 'ORIGIN_PASS',
    // 原主体认证已通过，新主体认证失败
    NEW_RETURN= 'NEW_RETURN',
    // 原主体认证已通过，新主体认证审核中
    NEW_AUDIT= 'NEW_AUDIT',
    // 原主体认证已通过，新主体认证通过
    NEW_PASS= 'NEW_PASS',
    // 自动撤回
    WITHDRAW= 'WITHDRAW',
    // 企业变更企业，原主体负责人刷脸阶段
    ORIGIN_FACE= 'ORIGIN_FACE',
    // 企业变更企业，原主体认证文件提交阶段
    ORIGIN_FILE= 'ORIGIN_FILE',
}

export const enum CHANGE_CHILD_TYPE {
    NORMAL_ONLINE_CHANGE = 'NORMAL_ONLINE_CHANGE', // 线上变更
    ORIGINAL_ENTITY_DEREGISTERED = 'ORIGINAL_ENTITY_DEREGISTERED', // 原主体已注销
}

export enum STUDENT_QUAILFY_STATUS {
    NONE = 'NONE', // 未认证
    AUDIT = 'AUDIT', // 认证进行中
    EXPIRED = 'EXPIRED', // 认证已过期
    PASS = 'PASS', // 认证已通过
    INVALID = 'INVALID', // 认证无效，如果用户实名被取消/变更实名，则学生认证状态被置为无效
}

export enum QUALIFY_CHANGE_STATE {
    ORIGIN_MAIN_BODY = 'ORIGIN_MAIN_BODY',
    NEW_MAIN_BODY = 'NEW_MAIN_BODY',
    NONE = 'NONE',
}

export enum QUALIFY_CHANGE_TYPE {
    PERSON_TO_PERSON = 'PERSON_TO_PERSON',
    PERSON_TO_CORPORATION = 'PERSON_TO_CORPORATION',
    CORPORATION_TO_CORPORATION = 'CORPORATION_REAL_CHANGE',
}

export type ChangeStateKey = keyof typeof CHANGE_STATE;

export const CHANGE_STATE = {
    origin: QUALIFY_CHANGE_STATE.ORIGIN_MAIN_BODY,
    new: QUALIFY_CHANGE_STATE.NEW_MAIN_BODY,
};

export type ChangeTypeKey = keyof typeof CHANGE_TYPE;

export const CHANGE_TYPE = {
    p2p: QUALIFY_CHANGE_TYPE.PERSON_TO_PERSON,
    p2c: QUALIFY_CHANGE_TYPE.PERSON_TO_CORPORATION,
    c2c: QUALIFY_CHANGE_TYPE.CORPORATION_TO_CORPORATION,
};

// 企业法人刷脸状态
export enum COMPANY_LEGAL_LIVING {
    FACE_AUTH_PASS = 'FACE_AUTH_PASS',
    FACE_AUTH_FAIL = 'FACE_AUTH_FAIL',
    WITHDRAW = 'WITHDRAW',
}

export enum PAYMENT_AUTH_STATUS {
    // 未创建充值认证
    PAYMENT_AUTH_INIT = 'PAYMENT_AUTH_INIT',
    // 已创建充值认证，且企业信息填写完毕
    PAYMENT_AUTH_CORP_INFO_FINISH = 'PAYMENT_AUTH_CORP_INFO_FINISH',
    // 充值认证已提交
    PAYMENT_AUTH_SUBMIT = 'PAYMENT_AUTH_SUBMIT',
    // 充值认证完成
    PAYMENT_AUTH_PASS = 'PAYMENT_AUTH_PASS',
    // 认证退回
    PAYMENT_AUTH_RETURN = 'PAYMENT_AUTH_RETURN',
    // 到期未打款
    PAYMENT_AUTH_OVERDUE = 'PAYMENT_AUTH_OVERDUE',
    WITHDRAW = 'WITHDRAW',
}

export enum EXCLUSIVE_ACCOUNT_STATUS {
    // 生成中
    AUDITING = 'AUDITING',
    // 生成中
    FAILED = 'FAILED',
    // 生效中
    EFFECTIVE = 'EFFECTIVE',
    // 专属账号被冻结
    FREEZE_AUDIT = 'FREEZE_AUDIT',
    // 专属账号被冻结
    FROZEN = 'FROZEN',
    // 专属账号被冻结
    FREEZE_FAILED = 'FREEZE_FAILED',
}

export enum QUALIFY_TYPE {
    ENTERPRISE = 'ENTERPRISE',
    PERSONAL = 'PERSONAL',
}

export const QualifyFacePipelineType: {
    [key in QualifyFaceType]: PipelineType | undefined;
} = {
    PERSONAL: 'PERSONAL_LIVING_BODY_AUTH',
    LEGAL: 'LEGAL_PERSON_FACE_AUTH_BAIDU_AI',
    REPRESENTATIVE: 'AUTHORIZED_PERSON_LIVING_BODY_AUTH',
    PERSONAL_H5: 'PERSONAL_LIVING_BODY_AUTH',
    LEGAL_H5: 'LEGAL_PERSON_FACE_AUTH_BAIDU_AI',
    REPRESENTATIVE_H5: 'AUTHORIZED_PERSON_LIVING_BODY_AUTH',
    REMIT: 'TRANSFER_TO_CORPORATION_UNION_PAY',
    COMPANY: undefined,
};

// 需要调用昊天镜风控检查的操作
// https://ku.baidu-int.com/knowledge/HFVrC7hq1Q/b_dB7xLNHi/7UjB4tIrOB/7ab53ee143bc48
export enum RiskCheckEv {
    personal = 'personal',
    face_submit = 'face_submit',
    card_send_code = 'card_send_code',
    card_submit = 'card_submit',
    certificate_submit = 'certificate_submit',
    face_start = 'face_start',
    enterprise = 'enterprise',
    legal_face_submit = 'legal_face_submit',
    authorized_submit = 'authorized_submit',
    remit_submit = 'remit_submit',
    remit_verify = 'remit_verify',
    recharge_apply = 'recharge_apply',
    recharge_submit = 'recharge_submit',
    pass_sync = 'pass_sync',
}

export const DEGREE_LEVEL = [
    {label: '专科', value: 'ASSOCIATE'},
    {label: '本科', value: 'BACHELOR'},
    {label: '研究生（硕士）', value: 'MASTER'},
    {label: '研究生（博士）', value: 'DOCTORATE'},
];
